import { render } from "./AddPatientsSmart.vue?vue&type=template&id=fe9a325e&scoped=true"
import script from "./AddPatientsSmart.vue?vue&type=script&lang=js"
export * from "./AddPatientsSmart.vue?vue&type=script&lang=js"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe9a325e"]])

export default __exports__